import { useBlocker } from '@/shared/hooks/useBlocker'
import { LevelPlayOutOfHearts, LevelPlayOutOfTime } from '@/shared/level-play'
import { Blocker } from '@/shared/ui/Blocker'

import { useQuizContext, withQuiz } from '../context'
import { DigitalProductQuizQuizFinish } from './Finish'
import { DigitalProductQuizQuizPlayQuestion } from './Question'

export const DigitalProductQuizShowPlay = withQuiz(() => {
  const {
    quiz,
    currentScreen,
    onQuizRestart,
    config: { SCREENS }
  } = useQuizContext()

  const { checkBlockCondition } = useBlocker()
  const blocked = checkBlockCondition(quiz?._blockCondition)

  // Paridade com a jornada (`journeys/Levels/Play/index.jsx`): a condição de
  // bloqueio é verificada na entrada, antes de montar qualquer step.
  //
  // O gate só age na tela inicial — quem já começou não é interrompido no meio
  // por uma condição que passou a valer durante a execução.
  //
  // `checkBlockCondition` devolve `unlocked: true` para condição ausente, então
  // um quiz sem `_blockCondition` degrada para liberado. É o modo de falha
  // certo: nunca prender o participante por dado faltando.
  if (!blocked.unlocked && currentScreen == SCREENS.INITIAL_SCREEN)
    return <Blocker blockCondition={quiz?._blockCondition} />

  if (currentScreen == SCREENS.OUT_OF_TIME_SCREEN)
    return <LevelPlayOutOfTime onRestart={onQuizRestart} />
  if (currentScreen == SCREENS.OUT_OF_HEARTS_SCREEN)
    return <LevelPlayOutOfHearts onRestart={onQuizRestart} />
  if (currentScreen == SCREENS.FINISH_SCREEN)
    return <DigitalProductQuizQuizFinish />
  else return <DigitalProductQuizQuizPlayQuestion />
})
